import React from 'react';
import './GalleryInfo.css';
import { Gallery } from '../../Gallery.interface';
import { environments } from 'environments/environments';
import { Link } from 'react-router-dom';
import { linkize, removeDiacritics } from 'libs/functions/string-operations';

const GalleryInfo = (props: { gallery: Gallery }) => {
  const g = props.gallery;

  const addDate = new Date(+g.addtime);
  // const upDate = new Date(+g.updatetime);
  const linkName = linkize(removeDiacritics(g.name), '-');

  const renderImage = g.mainphoto
    ? g.mainphoto.startsWith('http')
      ? <img src={g.mainphoto} alt="" />
      : <img src={environments.server + '/' + g.mainphoto} alt="" />
    : null;
  const renderAddDate = `Přidáno ${addDate.getDate()}. ${addDate.getMonth() + 1}. ${addDate.getFullYear()}`;
  // const renderUpDate = +g.updatetime ? `| Upraveno ${upDate.getDate()}. ${upDate.getMonth() + 1}. ${upDate.getFullYear()}` : '';
  const renderDescription = g.popis ? g.popis.replace(/&quot;/g, '"').split('\n').map((line, index) => <p className="gallery-info-desc" key={index}>{line} </p>) : null;
  const renderImagenum = +g.photos === 1
    ? '1 fotka'
    : +g.photos >= 2 && +g.photos <= 4
      ? `${g.photos} fotky`
      : `${g.photos} fotek`;

  return (
    <div className="section gallery-info">
      <div className="photo">
        {renderImage}
      </div>
      <div className="info">
        <p className="gallery-info-header">
          <Link to={`/fotky/${g.id}-${linkName}`}>
            {g.name ? g.name.replace(/&quot;/g, '"') : "-"}
          </Link>
        </p>
        <p className="gallery-info-dates">
          {renderAddDate} {/*renderUpDate*/} | {renderImagenum} v galerii
        </p>
        {g.popis
          ? renderDescription
          : null
        }
      </div>
    </div>
  );
}

export default GalleryInfo